import { SubInterestCategory } from '@src/containers/QuizContainer/types';

export const techInterestCategories: SubInterestCategory[] = [
	{
		name: 'Artificial Intelligence',
		description:
			'Helps computers think and solve problems like people. Used to improve areas like healthcare, business, and more.',
		facet: 'Technology > Artificial Intelligence',
	},
	{
		name: 'Computer Science & Programming',
		description:
			'Studies how computers work and how we can use them to solve problems. Programming involves writing code to run apps, websites, and games.',
		facet: 'Technology > Computer Science & Programming',
	},
	{
		name: 'Entertainment Technology',
		description:
			'Focuses on creating fun experiences like video games, movies, virtual reality, and special effects through hands-on training.',
		facet: 'Technology > Entertainment Technology',
	},
	{
		name: 'Information Systems & IT',
		description:
			'Involves storing, managing, and sharing information. Includes organizing data, setting up networks, and keeping systems secure for businesses.',
		facet: 'Technology > Information Systems & IT',
	},
	{
		name: 'Other Technology Programs',
		description: '',
		facet: 'Technology > Other Technology Programs',
	},
	{
		name: 'Security',
		description:
			'Protects computers, networks, and data from hackers and viruses. Keeps personal and business information safe from being stolen.',
		facet: 'Technology > Security',
	},
	{
		name: 'All technology programs',
		description: '',
		facet: 'All technology programs',
	},
];
